"use client";

import Image from "next/image";
import { Star } from "lucide-react";
import { Icons } from "./icons"
import clsx from "clsx";

interface ReviewCardProps {
  rating: number;
  text: string;
  userName: string;
  username: string;
  avatar: string;
  highlight?: boolean; // opcional: para destaque visual no futuro
  className?: string;
}

export function ReviewCard({
  rating,
  text,
  userName,
  username,
  avatar,
  highlight = false,
  className,
}: ReviewCardProps) {
  return (
    <div
      className={clsx(
        "flex flex-auto flex-col gap-4 bg-brand-25 p-6 sm:p-8 lg:p-16 transition hover:shadow-lg hover:-translate-y-1 rounded-3xl",
        highlight && "ring-2 ring-brand-600/30",
        className
      )}
    >
      {/* ⭐ Estrelas */}
      <div
        className="flex gap-0.5 mb-2 justify-center lg:justify-start"
        aria-label={`${rating} estrelas`}
        role="img"
      >
        {Array.from({ length: rating }).map((_, i) => (
          <Star key={i} className="size-5 text-brand-600 fill-brand-600" />
        ))}
      </div>

      {/* Texto do review */}
      <p className="text-base sm:text-lg lg:text-lg/8 font-medium tracking-tight text-brand-950 text-center lg:text-left text-pretty">
        {text}
      </p>

      {/* Usuário */}
      <div className="flex flex-col justify-center lg:justify-start sm:flex-row items-center sm:items-start gap-4 mt-2">
        <Image
          src={avatar}
          className="rounded-full object-cover"
          alt={userName}
          width={48}
          height={48}
        />

        <div className="flex flex-col items-center sm:items-start">
          <p className="font-semibold">
            {userName}
            <Icons.verificationBadge className="size-4 inline-block ml-1.5" />
          </p>
          <p className="text-sm text-gray-600">{username}</p>
        </div>
      </div>
    </div>
  );
}
